var map = {
	"./arrows.png": "e852",
	"./empty.png": "9f2c",
	"./four-grid-select.png": "e8b1",
	"./four-grid.png": "fef0",
	"./max-select.png": "e334",
	"./max.png": "088f",
	"./nine-grid-select.png": "086d",
	"./nine-grid.png": "a6db",
	"./one-grid-select.png": "fbf8",
	"./one-grid.png": "b248",
	"./six-grid-select.png": "68d9",
	"./six-grid.png": "b121",
	"./ys-four-grid-select.png": "9da8",
	"./ys-four-grid.png": "4942",
	"./ys-nine-grid-select.png": "9cfc",
	"./ys-nine-grid.png": "c71f",
	"./ys-one-grid-select.png": "0a16",
	"./ys-one-grid.png": "d593",
	"./ys-sixteen-grid-select.png": "f2d7",
	"./ys-sixteen-grid.png": "78a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "524e";